export default __webpack_public_path__ + "4afdd0d50492c75e881bf5461b4e0775.png";